import { createAction, props } from '@ngrx/store';

const feature = '[Signup Password]';

export const setPassword = createAction(`${feature} set password`, props<{ password: string }>());
